export enum BanType {
  Warn = 1,
  Ban = 2
}

export enum TargetType {
  Account = 1,
  Device = 2
}

export enum UserMemberTypeEnum {
  /**
   * 游客
   */
  Tourist = -1,
  /**
   * 学生
   */
  Student = 1,
  /**
   *  助教
   */
  TeachingAssistant = 2,
  /**
   * 助理
   */
  Assistant = 3,
  /**
   * 管理员
   */
  Admin = 4
}

export enum EnumAccountStatus {
  /** 正常 */
  Normal = 1,
  /** 禁用 */
  Ban = 2,
  /** 注销中 */
  Cancelling = 3,
  /** 已注销 */
  Cancelled = 4,
  /** 警告 */
  Warn = 5
}

export enum EnumLogoutType {
  /** 须知 */
  NOTICE = 'notice',
  /** 注销条件 */
  CONDITION = 'condition',
  /** 身份认证 */
  AUTH = 'auth',
  /** 检测账户 */
  ACCOUNT = 'account',
  /** 放弃资产 */
  ABANDON = 'abandon'
}

export enum EnumAbandonType {
  /** 放弃课程 */
  COURSE = 'course',
  /** 放弃虚拟资源 */
  RESOURCE = 'resource'
}
